// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__qbPUP","header":"styles_header__2F8oV","footer":"styles_footer__14sJ7","support":"styles_support__jWpPG"};